import React, { useContext } from 'react';
import { DropDownContext } from './custom-dropdown';

const DropDownOption = ({ option, onOptionClick, isPresent, edgeDiv = null }) => {
  const { hoveredOnOption, sethoveredOnOption, menuWidth = 160 } = useContext(DropDownContext);

  let isFirstChild = false,
    isLastChild = false;

  if (edgeDiv && edgeDiv.index === 0) {
    isFirstChild = true;
  } else if (edgeDiv && edgeDiv.index === edgeDiv.length - 1) {
    isLastChild = true;
  }

  return (
    <div
      style={{
        width: menuWidth,
        minWidth: menuWidth,
        borderRadius: isFirstChild ? '8px 8px 0 0' : isLastChild ? '0 0 8px 8px' : 0
      }}
      className={`menu-item ${isPresent(option) ? 'menu-item-active' : ''} ${isFirstChild ? 'menu-item-first' : isLastChild ? 'menu-item-last' : ''}`}
      onMouseEnter={() => sethoveredOnOption(null)}
      onMouseLeave={() => sethoveredOnOption(null)}
      onClick={(e) => onOptionClick({ e, option })}
    >
      {option.icon && (
        <img
          src={
            isPresent(option) && hoveredOnOption !== option.value
              ? option.icon.light
              : option.icon.dark
          }
          alt="icon"
          className="dropdown-item-icon"
        />
      )}
      <span style={{ fontFamily: 'Montserrat Regular' }}>{option.title}</span>
    </div>
  );
};

export default DropDownOption;
